export enum BillingSummaryModelType {
    Hold = 'Hold',
    Yes = 'Yes'
}
